export default "__VITE_ASSET__B8tc47sy__"